import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromLookups from '../../lookups';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { map } from 'rxjs/operators';
import clone from 'just-clone';
import { SelectItem } from 'primeng/api';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';

@Component({
    selector: 'ef-merge-feature',
    templateUrl: './merge-feature.component.html',
    styleUrls: ['./merge-feature.component.scss'],
    standalone: false
})
export class MergeFeatureComponent implements OnInit {
    public serviceItems$: Observable<SelectItem[]>;
    public tasks$: Observable<SelectItem[]>;
    process$: Observable<fromShared.Process>;

    public merge$: Observable<fromDataServices.Merge.Merge[]>;

    mergeDataService: EntityCollectionService<fromDataServices.Merge.Merge>;

    constructor(
        private log: LoggingService,
        private store: Store,
        public entityServices: EntityServices
    ) {
        this.mergeDataService =
            entityServices.getEntityCollectionService<fromDataServices.Merge.Merge>(
                fromDataServices.Merge.entityName
            );
    }

    ngOnInit(): void {
        this.store.dispatch(new fromLookups.LoadTasks());
        this.store.dispatch(new fromLookups.LoadServiceItems(false));

        this.setupObservables();
    }

    ngOnDestroy() {
        this.mergeDataService.clearCache();
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.merge$ = this.mergeDataService.entities$;
        this.serviceItems$ = this.store.pipe(
            select(fromLookups.getServiceItemsLookup),
            map(x => clone(x)),
            map(x => x.filter(y => y.IsActive == true)),
            map(x =>
                x.sort((a, b) => a.ServiceItem.localeCompare(b.ServiceItem))
            ),
            map(x => x.map(y => ({ label: y.ServiceItem, value: y.SIListID })))
        );

        this.tasks$ = this.store.pipe(
            select(fromLookups.getTasksLookup),
            map(x => clone(x)),
            map(x => x.filter(y => y.IsActive == true)),
            map(x =>
                x.sort((a, b) => a.TaskLongName.localeCompare(b.TaskLongName))
            ),
            map(x =>
                x.map(y => ({ label: y.TaskLongName, value: y.TaskListID }))
            )
        );
    }

    onMerge($event) {
        this.mergeDataService.clearCache();
        this.mergeDataService.upsert($event);
    }
}
